import { Alert, Button, Checkbox, Col, Divider, Form, Input, InputNumber, message, Row, Select, Space, Table, Tooltip, Typography } from "antd";
import { ColumnsType } from "antd/es/table";
import { useEffect, useState } from "react";
import { QuestionCircleOutlined, DownOutlined, ReloadOutlined } from '@ant-design/icons';
import EUtils, { IButtonConfig } from "../../../../utils/EUtils";
import URL from "../../../../server/URL";
import Server from "../../../../server/Server";
import EStorage from "../../../../utils/EStorage";

const AutoCode = (props: any) => {
    const [typeData, setTypeData] = useState<any>([]);
    const [dataSource, setDataSource] = useState<any>([]);

    const [codeFormatType, setCodeFormatType] = useState<any>(null);
    const [exampleIncluded, setExampleIncluded] = useState<string>('');
    const [exampleSN, setExampleSN] = useState<string>('');

    const columns: ColumnsType<any> = [
        {
            title: '序号', dataIndex: 'seqNO', key: 'seqNO', align: 'center', width: 60, ellipsis: true, fixed: 'left'
        },
        { title: '字段名称', dataIndex: 'fieldName', key: 'fieldName', align: 'center', width: 120, ellipsis: true },
        {
            title: '参与编码', dataIndex: 'isIncluded', key: 'isIncluded', align: 'center', width: 60, ellipsis: true,
            render(value, record, index) {
                return record.isBusinessSN ? '√' : <Checkbox checked={value} onChange={(e) => {
                    record.isIncluded = e.target.checked;
                    onChange(record, index);
                }} />
            },
        },
        {
            title: '位数/级', dataIndex: 'levelLimit', key: 'levelLimit', align: 'center', width: 60, ellipsis: true,
            render(value, record, index) {
                return <InputNumber style={{ width: '100%' }} value={value} onChange={(e) => {
                    record.levelLimit = e;
                    onChange(record, index);
                }} />
            },
        },
        {
            title: '分隔符', dataIndex: 'separator', key: 'separator', align: 'center', width: 60, ellipsis: true,
            render(value, record, index) {
                return <Input value={value} onChange={(e) => {
                    record.separator = e.target.value;
                    onChange(record, index);
                }} />
            },
        },
        {
            title: '参与复位', dataIndex: 'isRestore', key: 'isRestore', align: 'center', width: 60, ellipsis: true,
            render(value, record, index) {
                return record.isBusinessSN ? '×' : <Checkbox checked={value} onChange={(e) => {
                    record.isRestore = e.target.checked;
                    onChange(record, index);
                }} />
            },
        },
        {
            title: '实例', dataIndex: 'exampleData', key: 'exampleData', align: 'center', width: 145, ellipsis: true,
            render(value, record, index) {
                return <Input value={value} onChange={(e) => {
                    record.exampleData = e.target.value;
                    onChange(record, index);
                }} />
            },
        },
        {
            title: <>
                {'操作'}
                <span style={{ float: 'right' }}>
                    <Divider type='vertical' />
                    <ReloadOutlined style={{ alignItems: 'center', margin: '5px 0' }} onClick={() => getCodeFormat()} />
                </span>
            </>, dataIndex: 'option', key: 'option', align: 'center', width: 50,
            render(value, record, index) {
                var configs: IButtonConfig[] = [
                    { name: '上移', onClick: () => { onMoveUp(record); }, hidden: index == 0 },
                    { name: '下移', onClick: () => { onMoveDown(record); }, hidden: index == dataSource.length - 1 },
                ];
                return EUtils.InitButtons(configs);
            },
        }
    ]

    const onChange = (row: any, index: number) => {
        const newData = [...dataSource];
        const item = newData[index];
        newData.splice(index, 1, {
            ...item,
            ...row,
        });
        setDataSource(newData);
    }

    const [scrollY, setScrollY] = useState("")
    useEffect(() => {
        var appID = EUtils.getUrlParam('appID');
        if (appID) {
            getCodeFormatType(appID);
        }
        setScrollY(EUtils.getTableScroll(90, ''))
    }, [])

    const getCodeFormatType = (appID: any) => {
        var request = {
            id: appID
        };
        Server.Post(URL.CodeFormat.GetCodeFormatTypeOptions, request)
            .then((response: any) => {
                if (response.isSuccess) {
                    setTypeData(response.data);

                    if (response.data && response.data.length > 0) {
                        setCodeFormatType(response.data[0]);
                    }
                }
            })
    }

    const getCodeFormat = () => {
        var request = {
            codeFormatTypeID: codeFormatType?.value,
            buID: EStorage.CurrentBU()?.value
        };
        Server.Post(URL.CodeFormat.GetCodeFormatList, request)
            .then((response: any) => {
                if (response.isSuccess) {
                    setDataSource(response.data);
                }
            })
    }

    const onMoveUp = (record: any) => {
        if (record.codeFormatID) {
            var request = {
                codeFormatID: record.codeFormatID
            };
            Server.Post(URL.CodeFormat.MoveUpCodeFormat, request).then((response: any) => {
                if (response.isSuccess) {
                    message.success('上移成功');
                    getCodeFormat();
                }
            })
        } else {
            var index = dataSource.indexOf(record);
            swapElements(index, index - 1);
        }
    }

    const onMoveDown = (record: any) => {
        if (record.codeFormatID) {
            var request = {
                codeFormatID: record.codeFormatID
            };
            Server.Post(URL.CodeFormat.MoveDownCodeFormat, request).then((response: any) => {
                if (response.isSuccess) {
                    message.success('下移成功');
                    getCodeFormat();
                }
            })
        } else {
            var index = dataSource.indexOf(record);
            swapElements(index, index + 1);
        }
    }

    const swapElements = (index1: number, index2: number) => {
        // 创建一个新数组的副本
        const newItems = [...dataSource];

        // 交换元素位置
        const temp = newItems[index1];
        const temp2 = newItems[index2];
        newItems[index1] = {
            ...temp2,
            seqNO: temp.seqNO
        };
        newItems[index2] = {
            ...temp,
            seqNO: temp2.seqNO
        };

        // 更新状态
        setDataSource(newItems);
    };

    useEffect(() => {
        if (codeFormatType) {
            getCodeFormat();
        }
    }, [codeFormatType, props.bu])

    useEffect(() => {
        if (dataSource) {
            var filters = dataSource.filter((x: any) => x.isIncluded)
            var val = '';
            var sn = '';
            filters.sort((a: any, b: any) => a.seqNO - b.seqNO).map((i: any, idx: number) => {
                var data = getItemData(i);
                if (idx == 0) {
                    val = i.fieldName + i.separator;
                    sn = data + i.separator;
                } else {
                    val += i.fieldName + i.separator;
                    sn += data + i.separator;
                }
            });
            setExampleIncluded(val);
            setExampleSN(sn);
        }
    }, [dataSource])

    const getItemData = (i: any) => {
        var data = '';
        if (i.fieldNameEN.indexOf('BU') >= 0) {
            var dataArray = i.exampleData.split('.');
            var lastLength: number = dataArray.length - i.levelLimit > 0 ? dataArray.length - i.levelLimit : 0;
            for (let i = dataArray.length - 1; i >= lastLength; i--) {
                if (data == '') {
                    data = dataArray[i];
                } else {
                    data = dataArray[i] + '.' + data;
                }
            }
        }
        else if (i.isBusinessSN) {
            data = i.exampleData.slice(-i.levelLimit);
            var lastLength = i.levelLimit - i.exampleData.length;
            data = addZero(lastLength, data);
        }
        else {
            data = i.exampleData.slice(-i.levelLimit);
        }
        return data;
    }

    const addZero = (lastLength: number, data: string) => {
        if (lastLength > 0) {
            data = '0' + data;
            lastLength = lastLength - 1;
            data = addZero(lastLength, data);
        }
        return data;
    }

    const onSave = () => {
        var request = {
            codeFormatTypeID: codeFormatType?.value,
            buID: EStorage.CurrentBU()?.value,
            codeFormats: dataSource
        };
        Server.Post(URL.CodeFormat.SaveCodeFormat, request).then((response: any) => {
            if (response.isSuccess) {
                getCodeFormat();
                message.success('保存成功');
            }
        });
    }

    const filterOption = (input: any, option?: { label: any; value: any }) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

    return <div style={{ paddingBottom: '12px' }}>
        <div style={{ padding: '0', margin: 0 }}>
            <Col span={24}>
                <Form >
                    <Form.Item style={{ paddingBottom: '0px', margin: 0 }} label={'编码类别'}>
                        <Select labelInValue options={typeData} value={codeFormatType} onChange={(e) => {
                            setCodeFormatType(e);
                        }} showSearch
                            optionFilterProp="children"
                            filterOption={filterOption} />
                    </Form.Item>
                </Form>
            </Col>
        </div>
        <div style={{ paddingTop: '5px' }}>
            <Col span={24}>
                <div style={{ backgroundColor: '#fafafa', border: '1px solid #e7e7eb', borderBottom: 'none', padding: '5px' }}>
                    <Col span={24}>
                        <Alert
                            style={{ padding: '5px' }}
                            type="info"
                            description={<>
                                <Space direction="vertical">
                                    <span>{'参与编码字段：' + exampleIncluded}</span>
                                    <span>{'编码示例：' + exampleSN}</span>
                                </Space>
                            </>} />
                    </Col>
                </div>
                <Table size="small" bordered
                    scroll={{ x: 'max-content', y: scrollY }}
                    columns={columns}
                    dataSource={dataSource}
                    pagination={false}
                    summary={(pageData) => {
                        return (
                            <Table.Summary fixed>
                                <Table.Summary.Row >
                                    <Table.Summary.Cell index={0}>
                                        <Typography>{'合计：' + pageData.length}</Typography>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={1} colSpan={7} />
                                </Table.Summary.Row>
                            </Table.Summary>
                        );
                    }} />
            </Col>
        </div>
        <div style={{
            height: '32px', position: 'absolute', bottom: '8px', zIndex: 999, width: '99%'
            , padding: '2px',
            margin: 'auto',
            left: 0,
            textAlign: 'center'
        }}>
            <Space size={'small'}>
                <Button type="primary" disabled={(dataSource ?? []).length == 0} onClick={() => { onSave() }}>保存</Button>
            </Space>
        </div>
    </div>
}
export default AutoCode;